export default "__VITE_ASSET__BDbILEP$__"